import debounce from "./debounce";
import shuffle from "./shuffle";
import throttle from "./throttle";

export { debounce, shuffle, throttle };
